import React, { useRef, useState, useEffect } from "react"

interface MarqueeTextProps {
	text: string
}

const MarqueeText: React.FC<MarqueeTextProps> = ({ text }) => {
	const containerRef = useRef<HTMLDivElement>(null)
	const contentRef = useRef<HTMLDivElement>(null)
	const [shouldMarquee, setShouldMarquee] = useState(false)

	useEffect(() => {
		const container = containerRef.current
		const content = contentRef.current

		if (container && content) {
			setShouldMarquee(content.scrollWidth > container.clientWidth)
		}
	}, [text])

	return (
		<div className="marquee-container" ref={containerRef}>
			<div className={`marquee-content ${shouldMarquee ? "marquee-active" : ""}`} ref={contentRef}>
				{text}
			</div>
		</div>
	)
}

export default MarqueeText